@for (row of rows(); track row) {
    <div class="modal-panel modal-panel-input">
        @for (field of normalizedFields(); track field) {
            <div class="field">
                @if (!!field.label) {
                    <div class="ft-label">{{ field.label }}</div>
                }
                <input
                    [type]="type()"
                    [placeholder]="field.placeholder || ''"
                    [(ngModel)]="row.fieldData[field.name]"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="required()"
                    [pattern]="pattern()"
                    [minlength]="minLength()"
                    [attr.ng-maxlength]="maxLength()"
                    [style.direction]="isRtl(row.language) ? 'rtl' : 'ltr'"
                />
            </div>
        }
        @if (languages().length > 1) {
            <div class="language-code">{{ row.language.name }}</div>
        }
    </div>
}

@if (!isMultiLanguage()) {
    @for (field of normalizedFields(); track field) {
        <div class="modal-panel modal-panel-input">
            <div class="field">
                @if (!!field.label) {
                    <div class="ft-label">{{ field.label }}</div>
                }
                <input
                    [type]="type()"
                    [placeholder]="field.placeholder || ''"
                    [(ngModel)]="singleSource()[field.name]"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="required()"
                    [pattern]="pattern()"
                    [minlength]="minLength()"
                    [maxlength]="maxLength()"
                />
            </div>
        </div>
    }
}
